<script setup lang="ts">
import { DialogClose, DialogContent, DialogDescription, DialogPortal, DialogRoot, DialogTitle, DialogTrigger } from "reka-ui";
import { HiddenField } from "@formwerk/core";

defineProps<{ productId: number }>();
const { onSubmit, isSubmitting, result } = useAskLowerPriceForm();
</script>

<template>
  <div v-if="result.status === 'error'" class="prose text-danger">
    <p>{{ result.message }}</p>
  </div>
  <div v-else-if="result.status === 'success'">
    <p>{{ result.data.message }}</p>
  </div>
  <DialogRoot v-else>
    <DialogTrigger class="link-orange text-left text-xl text-primary">
      Vous avez trouvé un meilleur prix?
    </DialogTrigger>
    <DialogPortal>
      <UiDialogOverlay />
      <DialogContent class="animation-fade wp-max-h-screen fixed left-1/2 top-1/2 flex w-[calc(100%-32px)] max-w-screen-sm -translate-x-1/2 -translate-y-1/2 flex-col gap-2 overflow-y-scroll rounded-lg bg-white p-4 shadow-lg">
        <DialogTitle class="h3 text-primary">
          Meilleur prix
        </DialogTitle>
        <DialogDescription class="space-y-4">
          <p>Vous pouvez signaler les détails du prix et l'endroit où vous avez vu ce produit en remplissant les informations requises dans ce formulaire.</p>
          <form novalidate class="space-y-4" @submit="onSubmit">
            <HiddenField name="product_id" :value="productId" />
            <FieldText name="name" type="text" label="Nom" required />
            <FieldText name="email" type="text" label="Courriel" required />
            <FieldTextarea name="description" label="Description" required />
            <FieldNumber name="price" label="Meilleur prix" :min="1" :step="0.01" required>
              <template #suffix>
                <span class="i-lucide-dollar-sign size-6 text-muted" />
              </template>
            </FieldNumber>
            <UiSubmitButton :is-submitting="isSubmitting" />
          </form>
        </DialogDescription>
        <DialogClose class="absolute right-2 top-2">
          <span class="i-local-x size-6" />
        </DialogClose>
      </DialogContent>
    </DialogPortal>
  </DialogRoot>
</template>
